module.exports = __webpack_public_path__ + "assets/img/火箭.da9f7953.png";